<template>
  <div class="news-section-wrap">
    <div class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：
        <span class="breadcrumb-link" @click="$emit('go-home')">首页</span>
        <span> / </span>
        <span class="breadcrumb-link" @click="onBackToList">景区资讯</span>
        <span v-if="currentArticle"> / {{ sideMenu[activeSide] }}</span>
      </span>
    </div>
    <div class="news-section">
      <div class="news-sidebar">
        <div class="sidebar-title">景区资讯</div>
        <div class="side-menu">
          <div
            v-for="(item, index) in sideMenu"
            :key="index"
            class="side-item"
            :class="{ active: activeSide === index }"
            @click="onTabClick(index)"
          >{{ item }}</div>
        </div>
      </div>
      <div class="news-content">
        <template v-if="showList">
          <div class="content-header">
            <div class="content-title">{{ sideMenu[activeSide] }}</div>
          </div>
          <div class="news-list">
            <div v-for="(group, gIndex) in pagedGroups" :key="gIndex" class="list-group">
              <div
                v-for="(item, index) in group"
                :key="index"
                class="news-item"
                @click="openArticle(item)"
              >
                <span class="news-dot"></span>
                <span class="news-title">{{ item.title }}</span>
                <span class="news-date">{{ item.date }}</span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <span class="page-btn" @click="goFirst">首页</span>
            <span class="page-btn" @click="goPrev">上一页</span>
            <template v-for="(n, i) in pageNumbers" :key="i">
              <span v-if="n === '...'" class="page-ellipsis">...</span>
              <span v-else class="page-num" :class="{ active: currentPage === n }" @click="goPage(n)">{{ n }}</span>
            </template>
            <span class="page-btn" @click="goNext">下一页</span>
            <span class="page-btn" @click="goLast">尾页</span>
            <span class="page-info">共{{ totalPages }}页</span>
            <span class="page-jump">
              跳至<input type="text" v-model.number="jumpPage" class="jump-input">页
              <span class="jump-btn" @click="goJump">确认</span>
            </span>
          </div>
        </template>
        <template v-if="!showList">
          <div class="detail-title">{{ curTitle }}</div>
          <div class="detail-date">{{ curDate }}</div>
        <div class="detail-content">
          <div v-if="currentArticle.content" v-html="currentArticle.content"></div>
          <p v-else>{{ curDesc }}</p>
        </div>
          <div v-if="nextTitle" class="next-article" @click="goNextArticle">
            下一篇：{{ nextTitle }}
          </div>
          <div v-else class="next-article no-more">已是最后一篇</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticles, getArticleDetail, getPrevNext } from '../api/index'
import pointImg from '../assets/imgs/point.png'

export default {
  name: 'NewsSection',
  props: {
    tab: { type: Number, default: 0 },
    article: { type: Object, default: null },
  },
  emits: ['go-home'],
  data() {
    return {
      activeSide: this.tab,
      currentPage: 1,
      pageSize: 20,
      jumpPage: 1,
      currentArticle: null,
      nextArticle: null,
      currentIndex: -1,
      pointImg,
      sideMenu: ['通知公告', '景区动态'],
      noticeList: [],
      updateList: [],
      total: 0,
    }
  },
  computed: {
    newsList() {
      return this.activeSide === 0 ? this.noticeList : this.updateList
    },
    showList() {
      return !this.currentArticle
    },
    curTitle() {
      return this.currentArticle ? this.currentArticle.title : ''
    },
    curDate() {
      return this.currentArticle ? this.currentArticle.date : ''
    },
    curDesc() {
      const a = this.currentArticle
      return a ? (a.desc || a.title) : ''
    },
    nextTitle() {
      return this.nextArticle ? this.nextArticle.title : ''
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pagedGroups() {
      const groups = []
      for (let i = 0; i < this.newsList.length; i += 5) {
        groups.push(this.newsList.slice(i, i + 5))
      }
      return groups
    },
    pageNumbers() {
      const total = this.totalPages
      const cur = this.currentPage
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }
      const pages = []
      pages.push(1, 2)
      if (cur > 3) pages.push('...')
      if (cur > 2 && cur < total - 1) pages.push(cur)
      if (cur < total - 2) pages.push('...')
      pages.push(total - 1, total)
      return [...new Set(pages)]
    },
  },
  watch: {
    activeSide() {
      this.currentPage = 1
      this.currentArticle = null
      this.currentIndex = -1
      this.fetchNewsData()
    },
    tab(val) {
      this.activeSide = val
    },
    currentArticle(val) {
      if (val) this.$nextTick(() => { window.scrollTo(0, 0) })
    },
    currentPage: {
      handler(val) {
        const qp = parseInt(this.$route.query.newsPage) || 1
        if (qp !== val) this.$router.replace({ query: { ...this.$route.query, newsPage: val } }).catch(() => {})
      },
    },
    article: {
      immediate: true,
      handler(val) {
        if (val) {
          this.currentArticle = val
          this.currentIndex = this.newsList.indexOf(val)
          if (val.id) {
            this.fetchArticleDetail(val)
            this.$router.replace({ query: { ...this.$route.query, menu: 2, newsArticle: val.id, newsTab: this.activeSide, newsPage: 1 } }).catch(() => {})
          }
        }
      },
    },
    '$route.query.newsArticle': {
      handler(val) {
        if (!val) this.currentArticle = null
      },
    },
    '$route.query.newsPage': {
      handler(val) {
        const p = parseInt(val)
        if (p && p !== this.currentPage) { this.currentPage = p; this.fetchNewsData() }
      },
    },
  },
  mounted() {
    const p = parseInt(this.$route.query.newsPage)
    if (p) this.currentPage = p
    this.fetchNewsData()
  },
  methods: {
    async fetchNewsData() {
      const category = this.activeSide === 0 ? 'notices' : 'updates'
      try {
        const res = await getArticles({ category, lang: 'zh', pageNum: this.currentPage, pageSize: this.pageSize })
        if (res.code !== 200) return
        this.total = res.total || 0
        const list = (res.rows || []).map(item => ({
          id: item.id,
          title: item.title,
          date: (item.publishTime || '').substring(0, 10),
          desc: item.summary || '',
          coverImage: item.coverImage || '',
        }))
        if (this.activeSide === 0) {
          this.noticeList = list
        } else {
          this.updateList = list
        }
      } catch (e) {
        console.error('获取新闻数据失败:', e)
      }
    },
    async fetchArticleDetail(item) {
      try {
        const res = await getArticleDetail(item.id)
        if (res.code === 200 && res.data) {
          this.currentArticle = { ...item, ...res.data }
          const pn = await getPrevNext(item.id, { category: res.data.category, lang: res.data.lang || 'zh' })
          if (pn.code === 200 && pn.data) {
            this.nextArticle = pn.data.next
          }
        }
      } catch (e) {
        console.error('获取文章详情失败:', e)
      }
    },
    async openArticle(item) {
      this.currentArticle = { ...item }
      this.nextArticle = null
      this.currentIndex = this.newsList.indexOf(item)
      this.$router.push({ query: { ...this.$route.query, menu: 2, newsArticle: item.id } }).catch(() => {})
      if (item.id) {
        try {
          const res = await getArticleDetail(item.id)
          if (res.code === 200 && res.data) {
            this.currentArticle = { ...item, ...res.data }
            const pn = await getPrevNext(item.id, { category: res.data.category, lang: res.data.lang || 'zh' })
            if (pn.code === 200 && pn.data) {
              this.nextArticle = pn.data.next
            }
          }
        } catch (e) {
          console.error('获取文章详情失败:', e)
        }
      }
    },
    onTabClick(index) {
      this.activeSide = index
      this.currentArticle = null
      this.currentPage = 1
      this.$nextTick(() => {
        const q = { ...this.$route.query }
        q.newsTab = index
        q.newsPage = 1
        delete q.newsArticle
        this.$router.replace({ query: q }).catch(() => {})
      })
    },
    onBackToList() {
      this.currentArticle = null
      const q = { ...this.$route.query }
      delete q.newsArticle
      this.$router.replace({ query: q }).catch(() => {})
    },
    goNextArticle() {
      if (this.nextArticle) {
        const next = this.nextArticle
        this.currentArticle = { ...next }
        this.nextArticle = null
        if (next.id) this.fetchArticleDetail(next)
      }
    },
    goPage(n) {
      if (this.currentPage === n) return
      this.currentPage = n
      this.fetchNewsData()
    },
    goFirst() {
      if (this.currentPage === 1) return
      this.currentPage = 1
      this.fetchNewsData()
    },
    goPrev() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchNewsData()
      }
    },
    goNext() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.fetchNewsData()
      }
    },
    goLast() {
      if (this.currentPage === this.totalPages) return
      this.currentPage = this.totalPages
      this.fetchNewsData()
    },
    goJump() {
      const n = Number(this.jumpPage)
      if (n >= 1 && n <= this.totalPages && n !== this.currentPage) {
        this.currentPage = n
        this.fetchNewsData()
      }
    },
  },
}
</script>

<style scoped lang="less">
.news-section-wrap{
  padding-bottom: 0.4rem;
  .breadcrumb{
    padding-top: 0.2rem;
    padding-left: 0.1rem;
    padding-bottom: 0.2rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{ color: #369BF8; }
    }
  }
  .news-section{
    display: flex;
    margin-top: 0.3rem;
  gap: 0.2rem;
  .news-sidebar{
    width: 3.23rem;
    flex-shrink: 0;
    .sidebar-title{
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      font-size: 0.29rem;
      color: #fff;
      background: #369BF8;
    }
    .side-menu{
      border: 1px solid #e0e0e0;
      border-top: none;
      padding: 0.2rem 0;
      .side-item{
        height: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.24rem;
        color: #787A7B;
        cursor: pointer;
        position: relative;
        &::after{
          content: '';
          position: absolute;
          left: 0.15rem;
          right: 0.15rem;
          bottom: 0;
          height: 1px;
          background: #e0e0e0;
        }
        &:last-child::after{
          display: none;
        }
        &.active{
          font-size: 0.27rem;
          color: #1372C9;
          gap: 0.08rem;
          &::before{
            content: '';
            width: 0;
            height: 0;
            border-top: 0.06rem solid transparent;
            border-bottom: 0.06rem solid transparent;
            border-left: 0.09rem solid #369BF8;
            flex-shrink: 0;
          }
        }
      }
    }
  }
  .news-content{
    flex: 1;
    min-width: 0;
    min-height: 10rem;
    padding: 0 0.25rem;
    .content-header{
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 0.15rem;
      .content-title{
        display: inline-block;
        font-size: 0.27rem;
        color: #1372C9;
        border-bottom: 2px solid #1372C9;
        padding-bottom: 0.02rem;
        margin-bottom: -1px;
      }
    }
    .news-list{
      .list-group{
        margin-bottom: 0.15rem;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .news-item{
        display: flex;
        align-items: center;
        padding: 0.08rem 0;
        cursor: pointer;
        &:hover{
          background: rgba(0,0,0,.03);
        }
        .news-dot{
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          background: #0E8064;
          flex-shrink: 0;
          margin-right: 0.1rem;
        }
        .news-title{
          flex: 1;
          min-width: 0;
          font-size: 0.19rem;
          color: #2C2C2C;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 0.2rem;
        }
        .news-date{
          font-size: 0.19rem;
          color: #989898;
          flex-shrink: 0;
        }
      }
    }
  }
  .pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.05rem;
    margin: 0.4rem;
    flex-wrap: wrap;
    .page-btn, .page-num, .jump-btn{
      padding: 0.05rem 0.12rem;
      border: 1px solid #d9d9d9;
      font-size: 0.16rem;
      color: #333;
      cursor: pointer;
      user-select: none;
      background: #fff;
      &:hover{
        border-color: #369BF8;
        color: #369BF8;
      }
    }
    .page-num.active{
      background: #369BF8;
      color: #fff;
      border-color: #369BF8;
    }
    .page-info{
      font-size: 0.16rem;
      color: #666;
      margin-left: 0.1rem;
    }
    .page-jump{
      font-size: 0.16rem;
      color: #666;
      margin-left: 0.1rem;
      .jump-input{
        width: 0.5rem;
        height: 0.25rem;
        border: 1px solid #d9d9d9;
        text-align: center;
        font-size: 0.16rem;
        margin: 0 0.05rem;
        outline: none;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button{
          -webkit-appearance: none;
        }
      }
      .jump-btn{
        margin-left: 0.05rem;
      }
    }
  }
  .detail-title{
    font-size: 0.32rem;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-bottom: 0.15rem;
  }
  .detail-date{
    font-size: 0.18rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.3rem;
  }
  .detail-content{
    img{ max-width: 10rem; }
    p{
      font-size: 0.2rem;
      color: #4F4E4E;
      line-height: 2;
      text-indent: 2em;
      margin-bottom: 0.15rem;
    }
  }
  .next-article{
    margin-top: 0.4rem;
    font-size: 0.2rem;
    color: #369BF8;
    cursor: pointer;
    text-align: left;
    &:hover{ color: #1a6bb5; }
  }
}
}
</style>

